
import ArrowBottom from "../../../assets/duotone/ArrowBottom.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function ArrowBottomIcon({ className, dataTestid = "ArrowBottomIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <ArrowBottom data-testid={dataTestid} className={classes} {...rest} />
  );
}
